import type {ws} from '@/types';

export function convertSpotMarginOrder<Order extends ws.OrderBase>(
  orders: Order[]
): {
  spotOrders: Order[];
  marginOrders: Order[];
} {
  const spotOrders = [];
  const marginOrders = [];
  orders.forEach((o) => {
    if (o.hasOwnProperty('business') && o.business === 'UTA_SPOT') {
      spotOrders.push(o);
    } else {
      marginOrders.push(o);
    }
  });

  return {
    spotOrders,
    marginOrders,
  };
}
